import { Provider } from "src/app/shared/models/provider";


export enum ProviderByStatusAndLocation{
    ACTIVE_ADDRESS = 'ACTIVE_ADDRESS',
    ACTIVE_ZONE = 'ACTIVE_ZONE',
    INACTIVE_POSSIBLE_ADDRESS = 'INACTIVE_POSSIBLE_ADDRESS',
    INACTIVE_POSSIBLE_ZONE = 'INACTIVE_POSSIBLE_ZONE',
    INACTIVE_CANCELLED_ADDRESS = 'INACTIVE_CANCELLED_ADDRESS',
    INACTIVE_CANCELLED_ZONE = 'INACTIVE_CANCELLED_ZONE',
    INACTIVE_ADDRESS = 'INACTIVE_ADDRESS',
    INACTIVE_ZONE = 'INACTIVE_ZONE',
}

export type providerByStatusAndLocation = Record<ProviderByStatusAndLocation, Provider[] | null>;
export type loadingByStatusAndLocation = Record<ProviderByStatusAndLocation, boolean>;
